import BASE_URL from '../../utils/storage.js';
import { detailReadManager } from '../../api/detailReadManager.js';

export const normalizeMyCapabilities = (payload) => ({
  role: typeof payload?.role === 'string' ? payload.role.trim().toLowerCase() : null,
  features: payload?.features && typeof payload.features === 'object'
    ? payload.features
    : {},
});

export const featuresAPI = {
  async getMyCapabilities(authToken, options = {}) {
    const payload = await detailReadManager.getJson(`${BASE_URL}features/me/`, {
      method: 'GET',
      headers: {
        Authorization: `Token ${authToken}`,
        'Content-Type': 'application/json',
      },
    }, { ...options, priority: options.priority || 'visible', cacheTtlMs: 0 });

    return normalizeMyCapabilities(payload);
  },

  async getMyFeatures(authToken, options = {}) {
    const capabilities = await featuresAPI.getMyCapabilities(authToken, options);
    return capabilities.features;
  },
};

export default featuresAPI;
